import React, { useEffect } from "react";
import styled from "styled-components";
import "../../Assets/styles/customPhoneSelect.css";
import "react-phone-number-input/style.css";
import { useTranslate } from '@tolgee/react';
import { useSearchParams } from "react-router-dom";
import LoginButton from "../GenericComponents/LoginButton";

const CredentialsForDesktop = () => {

  const [searchParams, setSearchParams] = useSearchParams();

  const desktopToken = searchParams.get("access_token")

  const openApp = `emotii://desktop_app?access_token=${desktopToken}`

  const navigateInNewTab = (to) => {
    window.open("https://www.emotii.ai/terms");
  };


  const goToDesktopApp = () => {
    window.location = openApp
  }
  const { t } = useTranslate();


  return (
    <Container>
      <LeftSide>
        <Card>
          <Group>
            <h1>{t('login.successfull_log_in')}</h1>
          </Group>
          <Group>
            <LoginButton
              style={{ padding: "16px" }}
              onClick={(e) => goToDesktopApp(e)}
              text={t('login.go_to_desktop')}
            >

            </LoginButton>
            <TermsInfo onClick={() => navigateInNewTab("terms-and-conditions")}>
              <p>
                {t('login.login_agree')}
                <br />
                <span>{t('general.terms_and_conditions')}</span>
              </p>
            </TermsInfo>
          </Group>
        </Card>
      </LeftSide>
    </Container>
  );
};

export default CredentialsForDesktop;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 600px;
  width: 100%;
  gap: 40px;
  margin:auto;
`;
const Card = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 600px;
  width: 100%;
  gap: 20px;
`;

const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width:100%;
  h1 {
    color:${({ theme }) => theme.menu.primaryTextColor};
    font-size: 32px;
    font-weight: 600;
    line-height: 39px;
    letter-spacing: 0px;
    text-align: left;
  }
  p {
    color:${({ theme }) => theme.menu.secondaryTextColor};
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
    letter-spacing: 0px;
    text-align: left;
  }
`;

const LeftSide = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 32px;
`;


const TermsInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  p {
    color:${({ theme }) => theme.menu.secondaryTextColor};
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    text-align: center;
  }

  span {
    cursor: pointer;
     color:${({ theme }) => theme.menu.selectedTextColor};
    font-weight: 600;
    line-height: 22px;
    text-align: center;
    text-decoration: underline;
  }
`;